/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/

import {Component, EventEmitter, Input, TemplateRef, ChangeDetectionStrategy} from '@angular/core';
import {Placement} from '@ng-bootstrap/ng-bootstrap';

@Component({
    selector: 'app-claim-progress-marker',
    templateUrl: './claim-progress-marker.component.html',
    styleUrls: ['../../../styles/base.component.css', './claim-progress-marker.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ClaimProgressMarkerComponent {
    @Input() isError = false;
    @Input() closeTooltipEvent = new EventEmitter<void>();
    @Input() tooltipPlacement: Placement = 'bottom';
    @Input() tooltipTitle: string;
    @Input() tooltipMessage: TemplateRef<any>;
    @Input() tooltipToggle = new EventEmitter<boolean>();

    public disableTooltip(): boolean {
        return this.tooltipTitle == null || this.tooltipMessage == null;
    }
}
